// Author Pan Yu Rou
// Date 2024-08-09 16:06:00

import * as model from "@/model/sithMes/prd/SithMesPrdZpp1Model.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdZpp1(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
        callbackApi: process.env.VUE_APP_SITHMES_PRD_URL + '/sithMesPrdZpp1/complete-feedback',
        processDefinitionKey: "prd_zpp1",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
